import { render } from "./WalletIcon.vue?vue&type=template&id=05ceea3f"
import script from "./WalletIcon.vue?vue&type=script&lang=js"
export * from "./WalletIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__